import { config } from './grid'

export const span = (col = 1, breakpoint = 'min') => {
  const { cols, margin, gutter } = config[breakpoint]
  const gutterTotal = (cols - 1) * gutter
  return `calc((${(col / cols)} * (100vw - var(--scrollbar-width) - ${(margin * 2) + gutterTotal}px)) + ${gutter * col}px)`
}
